export default __webpack_public_path__ + "static/media/Asset-6.f049fd93.png";